import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import { errorSnack, successSnack } from "../snackbar/snackbarSlice";

import api from "../../app/api";

import { uuidv4 } from "../../app/utils";
import baseURL, { setXClientHost } from "../../app/utils.js";
import { fetchThemeJSON } from "../customisation/customisationSlice";


export const invalidateContents = createAsyncThunk(
  "contents/invalidateContents",
  async (args, thunkAPI) => {
      thunkAPI.dispatch(
          fetchThemeJSON({
              token: args.token,
              url: `${process.env.REACT_APP_ASSETS_URL}/theme/theme.json`,
          })
      );

      /*
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };

      const response = await api.patch(
        `${baseURL}/v1/admin/reset/cf_cache`,
        {
          path: args.path,
        },
        config
      );
      if (response.status === 200) {
        thunkAPI.dispatch(
          fetchThemeJSON({
            token: args.token,
            url: `${process.env.REACT_APP_ASSETS_URL}/theme/theme.json`,
          })
        );
      }

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching contents list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }

       */
  }
);

export const fetchContents = createAsyncThunk(
  "contents/fetchContents",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await api.get(
        `${baseURL}/v1/admin/contents?limit=100${args.query}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching contents list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreContents = createAsyncThunk(
  "contents/fetchMoreContents",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await api.get(
        `${baseURL}/v1/admin/contents${args.query}&offset=${args.offset}`,
        config
      );
      thunkAPI.dispatch(setContentsAmount(response.headers["x-total-count"]));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchContentByID = createAsyncThunk(
  "contents/fetchContentByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await api.get(
        `${baseURL}/v1/admin/contents/${args.id}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching content data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchContentByName = createAsyncThunk(
  "contents/fetchContentByName",
  async (args, thunkAPI) => {
    const config = {
      headers: {
        Authorization: `Bearer ${args.token}`,
        "X-Client-Host": args.host,
      },
    };
    try {
      const response = await api.get(
          // use rt API for rate limiting
        `${baseURL}/v1/rt/contents/name/${args.name}`,
        config
      );

      if (args.name == "logo") {
        thunkAPI.dispatch(setLogo(response.data.value));
      } else if (args.name == "social_links") {
        thunkAPI.dispatch(setSocial(response.data.value));
      } else if (args.name == "secondary_logo") {
        thunkAPI.dispatch(setSecondaryLogo(response.data.value));
      } else if (args.name == "secondary_logo_link") {
        thunkAPI.dispatch(setSecondaryLogoLink(response.data.value));
      } else if (args.name == "banner_message") {
        thunkAPI.dispatch(setBannerMessage(response.data.value));
      } else if (args.name == "promo_page_data") {
        thunkAPI.dispatch(setPromoPageData(response.data));
      } else if (args.name == "alertMessage") {
        thunkAPI.dispatch(setAlert(response.data.value));

        thunkAPI.dispatch(
          fetchShowAlert({ token: args.token, host: args.host })
        );
      } else {
        thunkAPI.dispatch(setContent(response.data));
      }
      return await response.data;
    } catch (error) {
    if (error.response && error.response.data) {
        /* alertMessage is buggy ~aidanf
            if (
            error.response.data.error_description == "content not found" &&
            args.name == "alertMessage"
            ) {
            thunkAPI.dispatch(
              createContent({
                token: args.token,
                name: "alertMessage",
                value: "",
                classification: "data",
                storageKey: null,
              })
            );
            }
             */
        if (
          args.name != "secondary_logo_link" &&
          args.name != "secondary_logo"
        ) {
          thunkAPI.dispatch(
            errorSnack(
              error.response.data.error_description ||
                "Error fetching Content data"
            )
          );
        }
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchLogo = createAsyncThunk(
  "contents/fetchLogo",
  async (args, thunkAPI) => {
    const config = {
      headers: {
        Authorization: `Bearer ${args.token}`,
        "X-Client-Host": args.host,
      },
    };
    try {
      const response = await api.get(
        `${baseURL}/v1/rt/contents/name/${args.name}`,
        config
      );

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        if (
          error.response.data.error_description == "content not found" &&
          args.name == "alertMessage"
        ) {
          thunkAPI.dispatch(
            createContent({
              token: args.token,
              name: "alertMessage",
              value: "",
            })
          );
        }
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching Content data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchShowAlert = createAsyncThunk(
  "contents/fetchShowAlert",
  async (args, thunkAPI) => {
    const config = {
      headers: {
        Authorization: `Bearer ${args.token}`,
        "X-Client-Host": args.host,
      },
    };
    try {
      const response = await api.get(
        `${baseURL}/v1/rt/contents/name/showAlert`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data.error_description == "content not found") {
          thunkAPI.dispatch(
            createContent({
              token: args.token,
              name: "showAlert",
              value: "false",
              classification: "data",
              storageKey: null,
            })
          );
        }
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching Content data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const deleteContent = createAsyncThunk(
  "contents/deleteContent",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.delete(
        `${baseURL}/v1/admin/contents/${args.id}`,
        config
      );
      thunkAPI.dispatch(successSnack("Content deleted"));
      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error deleting Content"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createContent = createAsyncThunk(
  "contents/createContent",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.post(
        `${baseURL}/v1/admin/contents`,
        args.content,
        config
      );
      thunkAPI.dispatch(successSnack("Content submitted successfully"));

      if (args.content.name === "promo_page_data") {
        thunkAPI.dispatch(setPromoPageData(response.data));
      }

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating Content"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateContent = createAsyncThunk(
  "contents/updateContent",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.patch(
        `${baseURL}/v1/admin/contents/${args.id}`,
        args.content,
        config
      );
      if (args.name == "social_links") {
        thunkAPI.dispatch(
          fetchContentByName({
            host: setXClientHost(),
            token: args.token,
            name: "social_links",
          })
        );
      } else if (args.name == "secondary_logo") {
        thunkAPI.dispatch(
          fetchContentByName({
            host: setXClientHost(),
            token: args.token,
            name: "secondary_logo",
          })
        );
      } else if (args.name === "promo_page_data") {
        thunkAPI.dispatch(setPromoPageData({ ...args.content, id: args.id }));
      }
      thunkAPI.dispatch(successSnack("Content updated successfully"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating content"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const preSignedURLcontents = createAsyncThunk(
  "contents/preSignedURL",
  async (args, thunkAPI) => {
    const config = {
      headers: {
        Authorization: `Bearer ${args.token}`,

      },
    };
    try {
      //full options
      const response = await api.post(
        `${baseURL}/v1/admin/pre_signed_url`,

        {
          objectName: `theme/${args.objectName}`,
          objectType: "asset",
          // objectType: args.objectType,
          objectContentType: args.contentType,
        },
        config
      );
      if (response.data.preSignedURL) {
        thunkAPI.dispatch(
          uploadThemeData({
            token: args.token,
            url: response.data.preSignedURL,
            contentType: args.contentType,
            file: args.file,
          })
        );
      }
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error creating pre-signed URL for file upload"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const uploadThemeData = createAsyncThunk(
  "contents/uploadThemeData",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {
          // Authorization: `Bearer ${args.token}`,
          "Content-Type": args.contentType,
            // Allow updates to show up immediately
            "Cache-Control": "no-cache, must-revalidate"
        },
        //
      };
      const response = await api.put(`${args.url}`, args.file, config);

      /*
      if (response.status === 200) {
        thunkAPI.dispatch(
          invalidateContents({
            token: args.token,
            path: `/theme/theme.json`,
          })
        );
      }

       */
      // thunkAPI.dispatch(successSnack(`File uploaded to s3`));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error uploading image to asset storage"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

/*
export const preSignedURLLogo = createAsyncThunk(
  "contents/preSignedURLLogo",
  async (args, thunkAPI) => {
    const config = {
      headers: {
        Authorization: `Bearer ${args.token}`,

      },
    };
    try {
      //full options
      const response = await api.post(
        `${baseURL}/v1/admin/pre_signed_url`,

        {
          // objectName: `theme/${args.objectName}`,
          objectName: `theme/logo/${args.objectName}`,
          objectType: "asset",
          objectContentType: args.contentType,
        },
        config
      );
      if (response.data.preSignedURL) {
        thunkAPI.dispatch(
          uploadCustomLogo({
            token: args.token,
            url: response.data.preSignedURL,
            contentType: args.contentType,
            file: args.file,
            logoContent: args.content,
          })
        );
      }
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error creating pre-signed URL for file upload"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const uploadCustomLogo = createAsyncThunk(
  "contents/uploadCustomLogo",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {
          // Authorization: `Bearer ${args.token}`,
          "Content-Type": args.contentType,

        },
        //
      };
      const response = await api.put(`${args.url}`, args.file, config);
      if (response.status === 200) {
        if (args.logoContent.length) {
          thunkAPI.dispatch(
            updateContent({
              token: args.token,
              content: {
                value: args.file.name,
              },
              id: args.logoContent[0].id,
            })
          );
        } else {
          thunkAPI.dispatch(
            createContent({
              token: args.token,
              content: {
                name: "logo",
                classification: "data",
                value: args.file.name,
                storageKey: null,
              },
            })
          );
        }
      }

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error uploading image to asset storage"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

 */

export const preSignedURLImage = createAsyncThunk(
    "contents/preSignedURLImage",
    async (args, thunkAPI) => {
        const config = {
            headers: {
                Authorization: `Bearer ${args.token}`,
            },
        };

        try {
            const response = await api.post(
                `${baseURL}/v1/admin/pre_signed_url`,
                {
                    objectName: args.objectName,
                    objectType: "asset",
                    objectContentType: args.file.type,
                },
                config
            );

            if (response.data.preSignedURL) {
                thunkAPI.dispatch(
                    uploadCustomImage({
                        token: args.token,
                        url: response.data.preSignedURL,
                        file: args.file,
                        contentName: args.contentName,
                        existingContent: args.existingContent,
                        filename: args.filename,
                    })
                );
            }

            return response.data;
        } catch (error) {
            if (error.response?.data) {
                thunkAPI.dispatch(
                    errorSnack(
                        error.response.data.error_description ||
                        "Error creating pre-signed URL for file upload"
                    )
                );
            }

            return thunkAPI.rejectWithValue({ error: error.message });
        }
    }
);

export const uploadCustomImage = createAsyncThunk(
    "contents/uploadCustomImage",
    async (args, thunkAPI) => {
        try {
            const response = await api.put(args.url, args.file, {
                headers: {
                    "Content-Type": args.file.type,
                },
            });

            const savedFileName = args.filename || args.file.name;

            if (response.status === 200) {
                if (args.existingContent?.length) {
                    thunkAPI.dispatch(
                        updateContent({
                            token: args.token,
                            content: {
                                value: savedFileName,
                            },
                            id: args.existingContent[0].id,
                        })
                    );
                } else {
                    thunkAPI.dispatch(
                        createContent({
                            token: args.token,
                            content: {
                                name: args.contentName,
                                classification: "data",
                                value: savedFileName,
                                storageKey: null,
                            },
                        })
                    );
                }
            }

            return response.data;
        } catch (error) {
            if (error.response?.data) {
                thunkAPI.dispatch(
                    errorSnack(
                        error.response.data.error_description ||
                        "Error uploading image to asset storage"
                    )
                );
            }

            return thunkAPI.rejectWithValue({ error: error.message });
        }
    }
);

export const preSignedURLBanner = createAsyncThunk(
  "contents/preSignedURLBanner",
  async (args, thunkAPI) => {
    const config = {
      headers: {
        Authorization: `Bearer ${args.token}`,
        
      },
    };
    try {
      //full options
      const response = await api.post(
        `${baseURL}/v1/admin/pre_signed_url`,

        {
          // objectName: `theme/${args.objectName}`,
          objectName: `theme/banner/${args.imgData.objectName}`,
          objectType: "asset",
          objectContentType: args.imgData.contentType,
        },
        config
      );
      if (response.data.preSignedURL) {
        thunkAPI.dispatch(
          uploadCustomBanner({
            token: args.token,
            url: response.data.preSignedURL,
            contentType: args.imgData.contentType,
            file: args.imgData.file,
          })
        );
      }
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error creating pre-signed URL for file upload"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const uploadCustomBanner = createAsyncThunk(
  "contents/uploadCustomBanner",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {
          // Authorization: `Bearer ${args.token}`,
          "Content-Type": args.contentType,

        },
        //
      };
      const response = await api.put(`${args.url}`, args.file, config);
      if (response.status === 200) {
      }

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error uploading image to asset storage"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateBannerImages = createAsyncThunk(
  "contents/updateBannerImages",
  async (args, thunkAPI) => {
    Promise.all(
      args.addedImages.map((imgData) =>
        thunkAPI.dispatch(preSignedURLBanner({ imgData, token: args.token }))
      )
    )
      .then((results) => {
        if (args.bannerContent.length) {
          thunkAPI.dispatch(
            updateContent({
              token: args.token,
              content: {
                value: args.fileNames.join(","),
              },
              id: args.bannerContent[0].id,
            })
          );
        } else {
          thunkAPI.dispatch(
            createContent({
              token: args.token,
              content: {
                name: "banner",
                classification: "data",
                value: args.fileNames.join(","),
                storageKey: null,
              },
            })
          );
        }
      })
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error updating banner images");
      });
  }
);

export const updateBannerLinks = createAsyncThunk(
  "contents/updateBannerLinks",
  async (args, thunkAPI) => {
    try {
      if (args.bannerContent.length) {
        thunkAPI.dispatch(
          updateContent({
            token: args.token,
            content: {
              value: args.bannerLinks.join(","),
            },
            id: args.bannerContent[0].id,
          })
        );
      } else {
        thunkAPI.dispatch(
          createContent({
            token: args.token,
            content: {
              name: "bannerLink",
              classification: "data",
              value: args.bannerLinks.join(","),
              storageKey: null,
            },
          })
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue("Error updating banner image links");
    }
  }
);

export const preSignedURLSecondaryLogo = createAsyncThunk(
  "contents/preSignedURLSecondaryLogo",
  async (args, thunkAPI) => {
    const config = {
      headers: {
        Authorization: `Bearer ${args.token}`,
      },
    };
    try {
      console.log("here3");

      const response = await api.post(
        `${baseURL}/v1/admin/pre_signed_url`,

        {
          // objectName: `theme/${args.objectName}`,
          objectName: `theme/secondary_logo/${args.objectName}`,
          objectType: "asset",
          objectContentType: args.contentType,
        },
        config
      );

      console.log("here4");

      if (response.data.preSignedURL) {
        thunkAPI.dispatch(
          uploadCustomSecondaryLogo({
            token: args.token,
            url: response.data.preSignedURL,
            contentType: args.contentType,
            file: args.file,
            logoContent: args.logoContent,
            secondaryLogoLink: args.secondaryLogoLink,
            linkContent: args.linkContent,
          })
        );
      }
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error creating pre-signed URL for file upload"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const uploadCustomSecondaryLogo = createAsyncThunk(
  "contents/uploadCustomSecondaryLogo",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {
          // Authorization: `Bearer ${args.token}`,
          "Content-Type": args.contentType,

        },
        //
      };
      const response = await api.put(`${args.url}`, args.file, config);
      if (response.status === 200) {
        if (args.logoContent.length) {
          thunkAPI.dispatch(
            updateContent({
              token: args.token,
              content: {
                value: args.file.name,
              },
              id: args.logoContent[0].id,
            })
          );
        } else {
          thunkAPI.dispatch(
            createContent({
              token: args.token,
              content: {
                name: "secondary_logo",
                classification: "data",
                value: args.file.name,
                storageKey: null,
              },
            })
          );
        }
        if (args.linkContent.length) {
          thunkAPI.dispatch(
            updateContent({
              token: args.token,
              content: {
                value: args.secondaryLogoLink,
              },
              id: args.linkContent[0].id,
            })
          );
        } else {
          thunkAPI.dispatch(
            createContent({
              token: args.token,
              content: {
                name: "secondary_logo_link",
                classification: "data",
                value: args.secondaryLogoLink,
                storageKey: null,
              },
            })
          );
        }
      }

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error uploading image to asset storage"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullContentsList = createAsyncThunk(
  "claims/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreContents(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full contents list");
      });
  }
);

const contentsSlice = createSlice({
  name: "contents",
  initialState: {
    content: {},
    contentsList: [],
    contentsFilter: [],
    showAlert: false,
    alertShown: false,
    loading: "idle",
    bannerLoading: false,
    bannerError: false,
    message: "",
    error: "",
    alert: {},
    logo: { value: "", loading: false, fetched: false },
    social: "",
      banner: "",
    bannerMessage: { value: "", loading: false, fetched: false },
    secondaryLogo: { value: "", loading: false, fetched: false },
    secondaryLogoLink: { value: "", loading: false, fetched: false },
    promoPageData: { value: "", id: null, loading: false, fetched: false },
    contentsAmount: "",
    lastQuery: "",
  },
  reducers: {
    setContent(state, action) {
      state.content = action.payload;
    },
    setLogo(state, action) {
      state.logo.value = action.payload;
      state.logo.fetched = true;
      state.logo.loading = false;
    },
    setSocial(state, action) {
      state.social = action.payload;
    },
    setSecondaryLogo(state, action) {
      state.secondaryLogo.value = action.payload;
      state.secondaryLogo.fetched = true;
      state.secondaryLogo.loading = false;
    },
    setSecondaryLogoLink(state, action) {
      state.secondaryLogoLink.value = action.payload;
      state.secondaryLogoLink.fetched = true;
      state.secondaryLogoLink.loading = false;
    },
  setBanner(state, action) {
      state.banner = action.payload;
    },
    setBannerMessage(state, action) {
      state.bannerMessage.value = action.payload;
      state.bannerMessage.fetched = true;
      state.bannerMessage.loading = false;
    },
    setPromoPageData(state, action) {
      state.promoPageData.value = action.payload.value;
      state.promoPageData.id = action.payload.id;
      state.promoPageData.fetched = true;
      state.promoPageData.loading = false;
    },
    setShowAlert(state, action) {
      state.showAlert = action.payload;
    },
    setAlert(state, action) {
      state.alert = action.payload;
    },
    setAlertShown(state, action) {
      state.alertShown = action.payload;
    },
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setContentsAmount: (state, action) => {
      state.contentsAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContents.pending, (state) => {
      state.contentsList = [];
      state.contentsFilter = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchContents.fulfilled, (state, { payload }) => {
      state.contentsList = payload;
      state.contentsFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchContents.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreContents.fulfilled, (state, { payload }) => {
      state.error = "";
      state.contentsList = state.contentsList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreContents.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullContentsList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.contentsList = state.contentsList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullContentsList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchContentByName.pending, (state, action) => {
      state.loading = "loading";
      const name = action.meta.arg.name;
      if (name === "logo") {
        state.logo.loading = true;
      } else if (name === "secondary_logo") {
        state.secondaryLogo.loading = true;
      } else if (name === "secondary_logo_link") {
        state.secondaryLogoLink.loading = true;
      } else if (name === "banner_message") {
        state.bannerMessage.loading = true;
      } else if (name === "promo_page_data") {
        state.promoPageData.loading = true;
      }
    });
    builder.addCase(fetchContentByName.fulfilled, (state, { payload }) => {
      // state.content = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchContentByName.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
      state.content = {};
      const name = action.meta.arg.name;
      if (name === "logo") {
        state.logo.loading = false;
        state.logo.fetched = true;
      } else if (name === "secondary_logo") {
        state.secondaryLogo.loading = false;
        state.secondaryLogo.fetched = true;
      } else if (name === "secondary_logo_link") {
        state.secondaryLogoLink.loading = false;
        state.secondaryLogoLink.fetched = true;
      } else if (name === "banner_message") {
        state.bannerMessage.loading = false;
        state.bannerMessage.fetched = true;
      } else if (name === "promo_page_data") {
        state.promoPageData.loading = false;
        state.promoPageData.fetched = true;
      }
    });
    builder.addCase(fetchLogo.pending, (state) => {
      state.loading = "loading";
      state.logo.loading = true;
    });
    builder.addCase(fetchLogo.fulfilled, (state, { payload }) => {
      state.logo.value = payload.value;
      state.logo.fetched = true;
      state.logo.loading = false;
      state.loading = "loaded";
    });
    builder.addCase(fetchLogo.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
      state.logo.loading = false;
      state.logo.fetched = true;
    });
    builder.addCase(fetchShowAlert.pending, (state) => {
      state.loading = "loading";
    });
    builder.addCase(fetchShowAlert.fulfilled, (state, { payload }) => {
      state.showAlert = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchShowAlert.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchContentByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchContentByID.pending, (state) => {
      state.content = {};
      state.loading = "loading";
    });
    builder.addCase(fetchContentByID.fulfilled, (state, { payload }) => {
      state.content = payload;
      state.loading = "loaded";
    });

    builder.addCase(deleteContent.pending, (state) => {
      state.message = "";
      state.loading = "loading";
    });
    builder.addCase(deleteContent.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(deleteContent.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createContent.pending, (state) => {
      state.message = "";
      state.loading = "loading";
    });
    builder.addCase(createContent.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(createContent.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(updateContent.pending, (state) => {
      state.loading = "loading";
    });
    builder.addCase(updateContent.fulfilled, (state, { payload }) => {
      state.loading = "loaded";
    });
    builder.addCase(updateContent.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(preSignedURLcontents.pending, (state) => {
      state.message = "";
      state.bannerError = false;
      state.loading = true;
    });
    builder.addCase(preSignedURLcontents.fulfilled, (state, { payload }) => {
      // state.message = payload;
    });
    builder.addCase(preSignedURLcontents.rejected, (state, action) => {
      state.bannerLoading = false;
      state.bannerError = true;
    });
    builder.addCase(uploadThemeData.pending, (state) => {
      state.bannerError = false;
      state.bannerLoading = true;
    });
    builder.addCase(uploadThemeData.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.bannerLoading = false;
    });
    builder.addCase(uploadThemeData.rejected, (state, action) => {
      state.bannerLoading = false;
      state.bannerError = true;
      state.error = action.error.message;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  setAlert,
  setContent,
  setLogo,
  setSocial,
  setSecondaryLogo,
  setSecondaryLogoLink,
  setBanner,
  setBannerMessage,
    setAlertShown,
  setPromoPageData,
  setLastQuery,
  setContentsAmount,
} = contentsSlice.actions;

export const selectContents = createSelector(
    (state) => ({
        contents: state.contents,
        contentsList: state.contents.contentsList,
        contentsFilter: state.contents.contentsFilter,
        showAlert: state.contents.showAlert,
        alertShown: state.contents.alertShown,
        loading: state.contents.loading,
        error: state.contents.error,
        content: state.contents.content,
        alert: state.contents.alert,
        logo: state.contents.logo,
        social: state.contents.social,
        secondaryLogo: state.contents.secondaryLogo,
        secondaryLogoLink: state.contents.secondaryLogoLink,
        promoPageData: state.contents.promoPageData,
        banner: state.contents.banner,
        bannerMessage: state.contents.bannerMessage,
        contentsAmount: state.contents.contentsAmount,
        lastQuery: state.contents.lastQuery,
    }),
    (state) => state
);

export default contentsSlice.reducer;
